import React from 'react';

export const FollowIcon = ({color}) => (
  <svg width="16px" height="20px" viewBox="0 0 16 20">
    <g fill={color} transform="translate(-55, 0)">
      <path d="M63,0 C62.172,0 61.5,0.672 61.5,1.5 L61.5,2.1953125 C58.9131836,2.862095 57,5.2048001 57,8 L57,14 L55,16 L55,17 L71,17 L71,16 L69,14 L69,8 C69,5.2048001 67.086816,2.862095 64.5,2.1953125 L64.5,1.5 C64.5,0.672 63.828,0 63,0 Z M61,18 C61,19.1 61.9,20 63,20 C64.1,20 65,19.1 65,18 L61,18 Z" />
    </g>
  </svg>
);

export const UnfollowIcon = ({color}) => (
  <svg width="22px" height="22px" viewBox="0 0 22 22">
    <g fill={color} transform="translate(-73, 0.000000)">
      <path d="M90.2928932,18 L78.6253907,6.33249746 L73.7071068,1.41421356 L75.1213203,2.93098879e-14 L79.8209925,4.69967213 C80.5570826,3.98609829 81.4757349,3.45932894 82.5,3.1953125 L82.5,2.5 C82.5,1.672 83.172,1 84,1 C84.828,1 85.5,1.672 85.5,2.5 L85.5,3.1953125 C88.086816,3.862095 90,6.2048001 90,9 L90,14.8786797 L94.9203102,19.7989899 L93.5060967,21.2132034 L90.2928932,18 Z M88.8786797,18 L76,18 L76,17 L78,15 L78,9 C78,8.42792014 78.0801391,7.8747943 78.2297905,7.35111088 L88.8786797,18 Z M82,19 L86,19 C86,20.1 85.1,21 84,21 C82.9,21 82,20.1 82,19 Z" />
    </g>
  </svg>
);
